import {Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

export interface DialogData {
  title: string;
  text: string;
}

@Component({
  selector: 'app-bestaetigungs-form',
  templateUrl: './bestaetigungs-form.component.html',
  styleUrls: ['./bestaetigungs-form.component.scss']
})
export class BestaetigungsFormComponent implements OnInit {

  public wertFuLoes;
  constructor(public dialogRef: MatDialogRef<BestaetigungsFormComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void { }

  /* Ja / Nein Buttons in im Löschen Bestätigungsformular */
  // tslint:disable-next-line:typedef
  public yesHandleClick() {
    this.dialogRef.close(true);
  }
  // tslint:disable-next-line:typedef
  public noHandleClick() {
    this.dialogRef.close(false);
  }
  /* ENDE Ja / Nein Buttons in im Löschen Bestätigungsformular */
  /* ENDE Menue vor dem Löschen bzw. Werte dem ja Pfad zuweisen */
}
